import React from 'react';
import './AwardSection.css';

const awards = [
  {
    image: '/award1.png',
    text: 'top software developers Techreviewer.co, 2025'
  },
  {
    image: '/award2.png',
    text: 'global excellence awards Acquisition Int., 2022'
  },
  {
    image: '/award3.png',
    text: 'BEST WORKPLACES EUROPE Great Places To Work, 2022'
  },
  {
    image: '/award4.png',
    text: 'TOP 1000 companies Clutch, 2024'
  },
  {
    image: '/award5.png',
    text: 'BEST ENTERPRISE DIGITAL ACCELERATION FDI insider, 2024'
  }
];

const AwardSection = () => {
  return (
    <section className="award-section">
      <div className="container">
      <h2 className="award-heading">WE ARE AN AWARD WINNING COMPANY</h2>
      <div className="award-items">
        {awards.map((award, index) => (
          <div key={index} className="award-card">
            <img src={award.image} alt={`Award ${index + 1}`} />
            <p>{award.text}</p>
          </div>
        ))}
      </div>
      </div>
    </section>
  );
};

export default AwardSection;